import { render, staticRenderFns } from "./AddMoreFields.vue?vue&type=template&id=1fd2320c"
import script from "./AddMoreFields.vue?vue&type=script&lang=js"
export * from "./AddMoreFields.vue?vue&type=script&lang=js"
import style0 from "./AddMoreFields.vue?vue&type=style&index=0&id=1fd2320c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports